import { createAction } from '@reduxjs/toolkit'

import type {
  Ga4CallbackFailure,
  Ga4Property,
  Ga4ReportResponse,
  Ga4ReportStatus,
  Ga4SelectProperty,
} from './types'

export const Ga4Actions = {
  fetchReport: createAction('GA4_FETCH_REPORT_REQUEST'),
  connect: createAction('GA4_CONNECT_REQUEST'),
  complete: createAction<string>('GA4_COMPLETE_REQUEST'),
  callbackFailed: createAction<Ga4CallbackFailure>('GA4_CALLBACK_FAILED'),
  disconnect: createAction('GA4_DISCONNECT_REQUEST'),
  fetchProperties: createAction('GA4_FETCH_PROPERTIES_REQUEST'),
  resync: createAction('GA4_RESYNC_REQUEST'),
  selectProperty: createAction<Ga4SelectProperty>(
    'GA4_SELECT_PROPERTY_REQUEST'
  ),
}

export const InternalGa4Actions = {
  reportLoaded: createAction<Ga4ReportResponse>('GA4_REPORT_LOADED'),
  reportFailed: createAction<Ga4ReportStatus>('GA4_REPORT_FAILED'),
  propertiesLoading: createAction('GA4_PROPERTIES_LOADING'),
  propertiesLoaded: createAction<Ga4Property[]>('GA4_PROPERTIES_LOADED'),
  connecting: createAction<boolean>('GA4_CONNECTING'),
  savingProperty: createAction<boolean>('GA4_SAVING_PROPERTY'),
  resyncing: createAction<boolean>('GA4_RESYNCING'),
  reset: createAction('GA4_RESET'),
}
